export default "__VITE_ASSET__2czUfEgx__"